import { createFileRoute } from "@tanstack/react-router";

import { Instagram } from "./-instagram/-components/instagram";

export const Route = createFileRoute("/instagram")({
	component: Instagram,
});
